"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTableId = exports.generateTableReference = void 0;
const utils_1 = require("./utils");
const generateTableReference = (translation) => {
    const lut = {};
    translation.books.forEach((book) => {
        book.videos.forEach((video) => {
            const iterator = (0, utils_1.chapterVerseIterator)(video);
            for (const [chapter, verse] of iterator) {
                if (lut[book.book_shortcode] === undefined) {
                    lut[book.book_shortcode] = {};
                }
                if (lut[book.book_shortcode][chapter] === undefined) {
                    lut[book.book_shortcode][chapter] = {};
                }
                lut[book.book_shortcode][chapter][verse] = video;
            }
        });
    });
    return lut;
};
exports.generateTableReference = generateTableReference;
const generateTableId = (translation) => {
    const tableId = {};
    translation.books.forEach((book) => {
        book.videos.forEach((video) => {
            tableId[video.bbb_id] = video;
        });
    });
    return tableId;
};
exports.generateTableId = generateTableId;
